import { stringContainsSubstringCaseInsensitive } from '@sonar-software/sonar-ts-lib';
export function caseInsensitiveContainsFilterOption(input, option) {
    return stringContainsSubstringCaseInsensitive(option === null || option === void 0 ? void 0 : option.label, input);
}
